import Banner from 'common/components/banner'
import { useAppSelector } from 'common/hooks/redux'
import { Info } from 'common/icons'
import {
  selectHasMigratedAccountEditAccess,
  selectIsAccountMigrated,
  selectMigratedRedirectUrl,
} from 'features/auth/store/authSlice'

export const messages = {
  migratedHeading: 'This account has moved to the new Jacquard platform',
  migratedText: 'Please make any changes there.',
  unknownHeading: 'We couldn’t check this account’s status',
  unknownText: 'Changes are disabled for this account.',
  editAccessNote: 'As Jacquard staff, you can still make changes.',
  cta: 'Go to the new Jacquard platform',
}

const MigratedAccountBanner = () => {
  const isMigrated = useAppSelector(selectIsAccountMigrated)
  const hasEditAccess = useAppSelector(selectHasMigratedAccountEditAccess)
  const redirectUrl = useAppSelector(selectMigratedRedirectUrl)
  const { migrationStatusUnknown, migratedToUrl } = useAppSelector(
    (state) => state.authStates
  )

  // A customer user with somewhere to go gets the redirect modal instead
  if (!isMigrated || (redirectUrl && !hasEditAccess)) {
    return null
  }

  const text = migrationStatusUnknown
    ? messages.unknownText
    : messages.migratedText

  return (
    <Banner
      type="info"
      icon={<Info size={4} isDefaultColor={false} className="text-base-700" />}
      heading={
        migrationStatusUnknown
          ? messages.unknownHeading
          : messages.migratedHeading
      }
      text={hasEditAccess ? `${text} ${messages.editAccessNote}` : text}
      cta={
        migratedToUrl && (
          <a
            href={migratedToUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="font-medium text-base-700 uppercase underline text-xs hover:opacity-50"
          >
            {messages.cta}
          </a>
        )
      }
    />
  )
}

MigratedAccountBanner.displayName = 'MigratedAccountBanner'

export default MigratedAccountBanner
